import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

export const mcpOrgContextQueryKey = (
  serverId: string,
  orgId: string | undefined,
) => ["mcpOrgContext", serverId, orgId];

export function useMcpOrgContext(serverId: string, orgId: string | undefined) {
  const { mcpRegistryService } = useDomainServices();

  return useQuery({
    queryKey: mcpOrgContextQueryKey(serverId, orgId),
    queryFn: ({ signal }) =>
      mcpRegistryService.getOrgContext(serverId, orgId!, {
        abortSignal: signal,
      }),
    enabled: orgId !== undefined,
    staleTime: 60_000,
  });
}
